import { set } from 'lodash'

import { SET_PROPERTY } from 'vx/mutations'

// state.
const state = {
  view_options: {
    show_times: false,
    show_description: true,
    show_technical_notes: true,
    show_testing_notes: true,
    show_recording: false,
    collapsed: true,
  },
  filters: {
    selectedGroups: [],
    selectedTags: [],
    estimation: 'Any'
  }
}

// usertstory settings state getters.
const getters = {}

// usertstory settings actions.
const actions = {}

// liabilities state mutations.
const mutations = {

  /**
   * Set a property on the state.
   *
   * @return void
   */
  [SET_PROPERTY] (state, { property, value }) {
    set(state, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
